import { useRef, useState } from "react";
import { toast } from "../../lib/notify";
import { Upload, FileSpreadsheet } from "lucide-react";
import { http, toastApiError, downloadUrl } from "../../lib/api";
import UploadErrorsButton from "../projects/UploadErrorsButton";

// Excel'den toplu demirbaş yükleme (şablon + dosya seçimi + sonuç özeti)
export default function AssetBulkUpload({ onDone }) {
  const fileRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [lastFile, setLastFile] = useState(null);
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    setUploading(true);
    try {
      const r = await http.post("/fixed-assets/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setResult(r.data); setLastFile(file);
      toast.success(`${r.data.created} yeni, ${r.data.updated} güncellendi${r.data.errors.length ? `, ${r.data.errors.length} hata` : ""}`);
      onDone();
    } catch (e) { toastApiError(e); } finally { setUploading(false); }
  };
  return (
    <div className="bg-white border border-dashed border-slate-300 rounded-lg p-4 flex items-center justify-between gap-4 flex-wrap" data-testid="asset-bulk-upload">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-md bg-emerald-50 text-emerald-700 inline-flex items-center justify-center"><FileSpreadsheet className="w-5 h-5" /></div>
        <div>
          <div className="text-sm font-semibold text-slate-900">Excel'den Toplu Demirbaş Yükle</div>
          <div className="text-[11px] text-slate-500">Şablonu indirin, doldurun ve yükleyin. Seri No eşleşen kayıtlar güncellenir; Zimmetli Proje adı ve Zimmetli Kişi (TC / Sicil No / Ad Soyad) ile eşleştirilir.</div>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <a href={downloadUrl("/fixed-assets/template")} target="_blank" rel="noreferrer" data-testid="asset-template" className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md border border-slate-300 bg-white text-xs font-semibold hover:bg-slate-50"><FileSpreadsheet className="w-3.5 h-3.5" /> Şablon İndir</a>
        <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="asset-upload" className="inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md bg-emerald-700 text-white text-xs font-semibold hover:bg-emerald-800 disabled:opacity-60"><Upload className="w-3.5 h-3.5" /> {uploading ? "Yükleniyor…" : "Excel Yükle"}</button>
        <input ref={fileRef} type="file" accept=".xlsx" className="hidden" data-testid="asset-upload-input" onChange={(e) => { if (e.target.files?.[0]) upload(e.target.files[0]); e.target.value = ""; }} />
      </div>
      {result && (
        <div className="w-full text-[11px] rounded-md border px-3 py-2 bg-slate-50 border-slate-200" data-testid="asset-upload-result">
          <span className="font-semibold text-emerald-700">{result.created} yeni</span> · <span className="font-semibold text-sky-700">{result.updated} güncellendi</span>
          <UploadErrorsButton file={lastFile} errors={result.errors} name="Demirbaş" testid="asset-upload-errors-xlsx" className="ml-2" />
          {result.errors.length > 0 && <ul className="mt-1 text-red-700 list-disc pl-4 space-y-0.5">{result.errors.slice(0, 10).map((er) => <li key={er}>{er}</li>)}{result.errors.length > 10 && <li>+{result.errors.length - 10} hata daha</li>}</ul>}
        </div>
      )}
    </div>
  );
}
